import {  Box } from "@mui/material";
import styled from "styled-components";


export const PaginationBox = styled(Box)`

    display: flex;
    justify-content: space-between;
    align-items: center;

    h6{
        color: #1B4A83;
        font-weight: 600;
        padding-left:10px;

        span{
            font-size:14px;
            font-weight: 500;
            fontFamily: '"Noto Sans", sans-serif',
            color: #000;
            padding-left: 6px;
        }
    }
    button {
        margin: 10px 0;
        border-radius: 2px;
    
}
.paginationContainer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Noto Sans', sans-serif;

    h6{
        color: #1B4A83;
        font-weight: 600;
        span{
            font-size:14px;
            font-weight: 500;
            color: #000;
            padding-left: 6px;
        }
    }
    button {
        margin: 10px 0;
        border-radius: 2px;
    
}
}
`;

